import { render } from "./EditChatbotModal.vue?vue&type=template&id=bbcc0364&scoped=true"
import script from "./EditChatbotModal.vue?vue&type=script&lang=js"
export * from "./EditChatbotModal.vue?vue&type=script&lang=js"

import "./EditChatbotModal.vue?vue&type=style&index=0&id=bbcc0364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbcc0364"]])

export default __exports__